import { CountCellProps } from '../../types';
import { formatNumberWithComma } from 'utils';

const ExceededRetriesCountsCell = ({ _customRowProps, data }: CountCellProps) => {
  return <div>{formatNumberWithComma(+data.exceededRetries)}</div>;
};

export default ExceededRetriesCountsCell;
